import { supabase } from '../supabase';

export async function castVote(snapId: string, optionId: string): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('User not authenticated');

  // First check if the user has already voted for this option
  const { data: existingVote } = await supabase
    .from('votes')
    .select('option_id')
    .eq('snap_id', snapId)
    .eq('user_id', user.id)
    .maybeSingle();

  // If user has already voted for this option, return early
  if (existingVote?.option_id === optionId) {
    throw new Error('You have already voted for this option');
  }

  // Use the RPC function to update the vote
  const { error: voteError } = await supabase.rpc('update_vote', {
    p_snap_id: snapId,
    p_user_id: user.id,
    p_option_id: optionId
  });

  if (voteError) {
    console.error('Error casting vote:', voteError);
    throw new Error('Failed to cast vote');
  }

  // Wait a moment to ensure the database has processed the vote
  await new Promise(resolve => setTimeout(resolve, 100));

  // Fetch updated vote counts to ensure UI is in sync with database
  const { error: refreshError } = await supabase
    .from('snap_options')
    .select('vote_count')
    .eq('snap_id', snapId);

  if (refreshError) {
    console.error('Error refreshing vote counts:', refreshError);
    throw new Error('Failed to refresh vote counts');
  }
}

export async function removeVote(snapId: string): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('User not authenticated');

  // Use the new RPC function to remove the vote and update counters atomically
  const { data, error } = await supabase.rpc('remove_vote', {
    p_snap_id: snapId,
    p_user_id: user.id
  });

  if (error) {
    console.error('Error removing vote:', error);
    throw new Error('Failed to remove vote');
  }

  if (!data) {
    throw new Error('No vote found to remove');
  }

  // Wait a moment to ensure the database has processed the changes
  await new Promise(resolve => setTimeout(resolve, 100));
}